import SubTable from 'src/components/commons/subTable';
import { DeleteOutlined } from '@ant-design/icons';
import PageContainer from 'src/components/pageContainer/PageContainer';
import { CustomLoadingModal } from 'src/components/commons/customModal';
import useTierTable from './hooks/useTierTable';
import StyleInfinityScroll from '../../../../styles/StyleInfinityScroll.style';

const TabTierTable = () => {
  const {
    autocompleteFieldSearch,
    handleFilterChange,
    handleSortModelChange,
    setColumns,
    columns,
    handleUpdateRows,
    handleDeleteRows,
    newRecord,
    postData,
    createNewRecord,
    resetNewRecord,
    queryResponse,
    handleClearFilter,
    dataSource,
  } = useTierTable();

  return (
    <>
      {queryResponse.loading && <CustomLoadingModal modalStatus />}
      <PageContainer margin='2rem'>
        <StyleInfinityScroll>
          <SubTable
            data={dataSource}
            columns={columns}
            setColumns={setColumns}
            autocompleteFieldProvider={autocompleteFieldSearch}
            onFilterChange={handleFilterChange}
            onSortChange={handleSortModelChange}
            handleUpdateRows={handleUpdateRows}
            onDeleteClick={handleDeleteRows}
            scroll={{ y: '60vh', x: '90vw' }}
            actionCell={['delete']}
            detailsIcon={<DeleteOutlined />}
            headerActions={['filter', 'edit', 'delete']}
            id='tier-table'
            showOptionFilterLeft={false}
            newRecord={newRecord}
            saveNewRecord={createNewRecord}
            postData={postData}
            resetNewRecord={resetNewRecord}
            allowGlobalEditActive
            total
            nonGlobalFilterable
            showAutoIncrement
            clearFilter={handleClearFilter}
            columnFilterShown
          />
        </StyleInfinityScroll>
      </PageContainer>
    </>
  );
};
export default TabTierTable;
